<form class="w-100 d-flex" [formGroup]="formGroup" *ngIf="sorts$ | async as sorts">
  <ng-container *ngIf="sorts?.length">
    <py-dropdown
      class="w-100 articles-sort-dropdown"
      [formControlName]="'sort'"
      [options]="sorts"
      [analyticsEventCode]="'catalog_sort'"
      [heading]="'catalog.pdp.sortBy_heading' | cxTranslate"
      [title]="'catalog.pdp.sortBy_heading' | cxTranslate"
    ></py-dropdown>
    <py-action-button
      class="ml-2"
      [disabled]="revertOrderDisabled"
      (activate)="revertSortOrder()"
      [buttonClass]="'btn btn-ternary btn-icon'"
      [ngbTooltip]="(isDirectionDesc ? 'catalog.sortDescending_tooltip' : 'catalog.sortAscending_tooltip') | cxTranslate"
      [ariaLabel]="(isDirectionDesc ? 'catalog.sortDescending_tooltip' : 'catalog.sortAscending_tooltip') | cxTranslate"
    >
      <i nz-icon nzType="arrow-down" [ngClass]="{ swap: isDirectionDesc }"></i>
    </py-action-button>
  </ng-container>
</form>
